module.exports = __webpack_public_path__ + "static/media/3.12631f74.jpg";